// @flow

import styled, { css } from 'styled-components';
import {
  grid, gridTemplateColumns, gridTemplateRows, gridArea,
} from '../../../helpers/gridHelpers';
import {
  ContentWrapper,
  Title as DefaultTitle,
  Description as DefaultDescription,
} from '../components';
import { media } from '../../../helpers';
import type { Theme } from '../../../types';

type ContainerProps = {
  largeIcon: boolean;
};

export const Container = styled<any, Theme, ContainerProps>('section')`
  ${grid()}
  ${gridTemplateColumns('1fr 8.25rem 1fr')}
  ${gridTemplateRows('3.75rem 4.5rem 1fr auto')}

  filter: drop-shadow(${props => props.theme.iconText.dropShadow});
  grid-template-areas:
    ". icon ."
    ". icon ."
    "cnt cnt cnt"
    "btn btn btn";
  height: 100%;

  ${media.lg(css`
    ${gridTemplateColumns('1fr 8.25rem 1fr')}
    ${gridTemplateRows('3.75rem 4.5rem 1fr auto')}
  `)};

  ${props => props.largeIcon && css`
    ${gridTemplateColumns('1fr 10rem 1fr')}
    ${gridTemplateRows('4rem 6rem 1fr auto')}
    ${media.lg(css`
      ${gridTemplateColumns('1fr 12rem 1fr')}
      ${gridTemplateRows('4.75rem 7.25rem 1fr auto')}
    `)};
  `}
`;

export const Box = styled<any, Theme>('div')`
  ${gridArea('2 / 1 / 5 / 4')}

  border-radius: ${props => props.theme.iconText.borderRadius};
  background-color: ${props => props.theme.iconText.backgroundColor};
  box-shadow: ${props => props.theme.iconText.boxShadow};
  @supports (display: grid) {
    box-shadow: none;
  }
`;

export const Icon = styled<any, Theme>('header')`
  ${gridArea('1 / 2 / 3 / 3')}
  background-color: ${props => props.theme.iconText.backgroundColor};
  border: .5rem solid ${props => props.theme.iconText.backgroundColor};
  border-radius: 50%;

  height: calc(100% - 1rem);
  width: calc(100% - 1rem);

  > div {
    height: 100%;
    width: 100%;
  }
`;

export const Content = styled<typeof ContentWrapper, Theme>(ContentWrapper)`
  ${gridArea('3 / 1 / 4 / 4')}
  padding: 1rem 1.5rem 1.5rem;
  text-align: center;
`;

export const Title = styled<typeof DefaultTitle, Theme>(DefaultTitle)`
  padding-bottom: .75rem;
  text-align: center;
`;

export const Description = styled<typeof DefaultDescription, Theme>(DefaultDescription)`
  text-align: center;
`;

export const ButtonWrapper = styled<any, Theme>('footer')`
  ${gridArea('4 / 1 / 5 / 4')}
  justify-content: center;
  display: flex;
  padding: 0 1.5rem 1rem;
`;

export default null;
